import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';

@Component({
    selector: 'app-comentario-ui-edit',
    templateUrl: './comentario-ui-edit.component.html',
    styleUrls: ['./comentario-ui-edit.component.scss'],
})
export class ComentarioUiEditComponent extends ComponentBase implements OnInit {
    @Input() formGroup: FormGroup;

    isCollapsedCabecera: boolean;

    constructor(
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.form = this.formGroup; // componentBase uses this.form
    }
}
